// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Assets_wrapper__3xO6w","left":"Assets_left__3uTD1"};